<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconScreenRotation_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12.5 6.167a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5zm-.75 3.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M12.407 4.89h-2.371a.57.57 0 0 1-.423-.17.57.57 0 0 1-.17-.423q0-.252.17-.423a.57.57 0 0 1 .423-.17h.533a3.95 3.95 0 0 0-1.334-.882 4.2 4.2 0 0 0-1.57-.304q-1.053 0-1.972.497A4.04 4.04 0 0 0 4.211 4.37q-.207.297-.444.34a.7.7 0 0 1-.445-.058.57.57 0 0 1-.289-.312.43.43 0 0 1 .037-.4 5.26 5.26 0 0 1 1.934-1.904 5.24 5.24 0 0 1 2.66-.704 5.3 5.3 0 0 1 4.15 1.986V1.926q0-.253.17-.423a.57.57 0 0 1 .423-.17q.252 0 .422.17.17.171.17.423v2.37a.57.57 0 0 1-.17.423.57.57 0 0 1-.422.17"
    />
</svg>
